import { INFO_BUTTON_CLASS } from '|>/shared/constants/classes'
import { Events } from '|>/shared/events'
import { on, register } from '|>/shared/vjs'
import { BaseButton } from '../base'

import './info-button.css'

/**
 * Bottom-right info button component
 * https://github.com/videojs/video.js/blob/e78bcc7b2d829fce01451cf105b918d8feec4548/src/js/button.js
 */
@register
export class InfoButton extends BaseButton {
  @on(Events.Controls.ShowInfoControl)
  changeVisibility(visible: Events.Controls.ShowInfoControl) {
    if (visible) this.show()
    else this.hide()
  }

  override handleClick(event: Event) {
    event.preventDefault()
    event.stopPropagation()

    this.player_.trigger(Events.Player.InfoClick)
  }
}

InfoButton.options = {
  className: INFO_BUTTON_CLASS,
}
